export default "assets/images/flags/fr-3cdaee08.svg";